import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import PlanetNotify from '@/utils/planetNotify'
import { loadConfig } from '@/utils/config'
import waterfall from 'vue-waterfall2'

Vue.use(ElementUI)
Vue.use(PlanetNotify)
Vue.use(waterfall)

Vue.config.productionTip = false

// 先加载配置，再初始化应用
loadConfig().then(() => {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})
